var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    d: "M31 20.714c.71 0 1.286.576 1.286 1.286 0 .66-.497 1.203-1.136 1.277l-.15.009H13c-.71 0-1.286-.576-1.286-1.286 0-.66.497-1.203 1.136-1.277l.15-.009h18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    d: "M21.09 12.09c.503-.501 1.317-.501 1.82 0 .463.464.498 1.194.106 1.698l-.107.121L14.82 22l8.09 8.09c.464.464.5 1.194.107 1.698l-.107.121c-.463.464-1.193.5-1.697.107l-.121-.107-9-9c-.464-.463-.5-1.193-.107-1.697l.107-.121 9-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowActive);
export default __webpack_public_path__ + "static/media/back-arrow-active.87d6a212c3ece00ab42b0df313a588f8.svg";
export { ForwardRef as ReactComponent };